module.exports = __webpack_public_path__ + "img/project_color.173847f1.svg";